<template>
    <front-layout title="Perguntas Frequentes">
        <div class="py-40 container mx-auto px-4">
            <h2 class="font-semibold text-2xl lg:text-4xl text-gray-300 leading-tight mb-8 md:mb-0">Perguntas Frequentes</h2>

            <div class="mt-10">
                <div class="w-full lg:w-2/3 mx-auto">
                    <div v-for="(faq, index) in faqs" class="my-4">
                        <button class="bg-white shadow p-6 text-center rounded-full lg:text-lg text-left hover:font-bold focus:font-bold w-full" @click.prevent="togglePanel(index)">{{faq.question}}</button>
                        <span v-show="showPanel == index" class="transition">
                            <div class="bg-white p-10 mt-2 rounded-lg shadow">
                                <p class="text-left leading-7" v-html="keepFormat(faq.answer)"></p>
                            </div>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </front-layout>
</template>

<style scoped>
</style>


<script>
    import { defineComponent } from 'vue'
    import FrontLayout from '@/Layouts/FrontLayout.vue'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import Icon from '@/Jetstream/Icon.vue'
    import Tabs from '@/Components/Tabs.vue'

    export default defineComponent({
        components: {
            Head,
            Link,
            FrontLayout,
            Icon,
            Tabs
        },
        props: {
            canLogin: Boolean,
            canRegister: Boolean,
            laravelVersion: String,
            phpVersion: String,
            faqs: Array
        },
        data() {
            return {
                showPanel: null,
                activeTab: null
            }
        },
        computed: {
           
        },
        methods: {
            togglePanel(i) {
                this.showPanel = i
            },
            keepFormat(e) {
                return e.replace(/\n/g, "<br>\n")
            }
        },
    })
</script>
